"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ForgotPassword_1 = __importDefault(require("./ForgotPassword"));
exports.default = ForgotPassword_1.default;
